import VeilederUtlandDto from '../Models/VeilederUtlandDto';
import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';

const afrika = 'b1-afrika';
const asia = 'b2-asia';
const europa = 'b3-europa';
const nordMellomAmerika = 'b4-nordMellomAmerika';
const oseania = 'b5-oseania';
const sorAmerika = 'b6-sorAmerika';

const bValg: RadioButtonValgModel<VeilederUtlandDto>[] = [
    { id: 'afrika', value: afrika, tekst: 'valgAfrika' },
    { id: 'asia', value: asia, tekst: 'valgAsia' },
    { id: 'europa', value: europa, tekst: 'valgEuropa' },
    { id: 'nordmellomamerika', value: nordMellomAmerika, tekst: 'valgNordMellomAmerika' },
    { id: 'oseania', value: oseania, tekst: 'valgOseania' },
    { id: 'soramerika', value: sorAmerika, tekst: 'valgSorAmerika' }, 
];

export default {
    b1_afrika: afrika,
    b2_asia: asia,
    b3_europa: europa,
    b4_nordMellomAmerika: nordMellomAmerika,
    b5_oseania: oseania,
    b6_sorAmerika: sorAmerika,
    bValg,
};